import React from "react"
import Box from "~/components/Common/Box"
import AccessLinks from "../AccessLinks"
import ApiKeys from "../ApiKeys"
import ClientCourses from "../ClientCourses"
import useStyles from "./styles"

const RightContainer = () => {
  const classes = useStyles()

  return (
    <Box className={classes.container}>
      <ApiKeys />
      <AccessLinks />
      <ClientCourses />
    </Box>
  )
}

RightContainer.propTypes = {}
export default RightContainer
